import { ProductListInteractionType } from "../types";

// Recommender event_type
export const EVENT_RECOMMENDER_EVENT_TYPE = "recommended_bi";

// Product list interaction types
export const PRODUCT_LIST_INTERACTION_TYPES: Record<
  ProductListInteractionType,
  number
> = {
  click: 1,
  option: 2,
  addToCart: 3,
};

// OnePass
export const ONEPASS_CATEGORY = "OnePass";
export const ONEPASS_ACTION_UPSELL_NUDGE = "Upsell Nudge";
export const ONEPASS_ACTION_UPSELL_MODAL = "Upsell Modal";
export const ONEPASS_ACTION_UPSELL_MODAL_HEADER = "Upsell Modal Header";
export const ONEPASS_NOTIFICATION_LABEL_SUCCESS = "Success Message";
export const ONEPASS_NOTIFICATION_LABEL_ERROR = "Error Message";
export const ONEPASS_ACTION_MIGRATION_RESULT = "Migration Result";
export const ONEPASS_ACTION_MIGRATION_NUDGE = "Migration Nudge";
export const ONEPASS_ACTION_LINKING_MODAL = "Linking Modal";
export const ONEPASS_ACTION_LINKING_EXIST_MODAL = "Linking Exist Modal";
export const ONEPASS_ACTION_LINKING_RESULT = "Linking Result";
export const ONEPASS_ACTION_UPSELL_RESULT = "Upsell Result";
export const ONEPASS_MIGRATION_FLASH_MSG_LABEL_SUCCESS = "Success Message";
export const ONEPASS_MIGRATION_FLASH_MSG_LABEL_ERROR = "Error Message";
